import { getObject, RepositoryKey, setObject } from "utils/repository";

interface WorkflowSettings {
    autoRefresh?: boolean;
}

interface WorkflowSettingsMap {
    [workflowUuid: string]: WorkflowSettings;
}

export function getWorkflowSettings(workflowUuid: string): WorkflowSettings {
    const map = getObject<WorkflowSettingsMap>(RepositoryKey.BMP_WORKFLOW_SETTINGS) || {};
    return map[workflowUuid] || {};
}

export function updateWorkflowSettings(workflowUuid: string, settings: Partial<WorkflowSettings>): void {
    const map = getObject<WorkflowSettingsMap>(RepositoryKey.BMP_WORKFLOW_SETTINGS) || {};

    if (!map[workflowUuid]) {
        map[workflowUuid] = {};
    }

    map[workflowUuid] = { ...map[workflowUuid], ...settings };

    if (Object.keys(map[workflowUuid]).length === 0) {
        delete map[workflowUuid];
    }

    setObject(RepositoryKey.BMP_WORKFLOW_SETTINGS, map);
}

export function getWorkflowAutoRefreshState(workflowUuid: string): boolean {
    return getWorkflowSettings(workflowUuid).autoRefresh || false;
}

export function setWorkflowAutoRefreshState(workflowUuid: string, enabled: boolean): void {
    updateWorkflowSettings(workflowUuid, { autoRefresh: enabled });
}
